import { IntlShape } from 'react-intl'
import { IScheduleDropdownDay } from '../../../components/dropOffLocationDetails/ScheduleDropdown'

export interface IScheduleOpenTimes {
  days: Array<IScheduleDropdownDay>
  isOpenNow: boolean
}

const openingStatusText = (scheduleOpenTimes: IScheduleOpenTimes, intl: IntlShape): string => {
  const date = new Date()
  // Open
  if (scheduleOpenTimes.isOpenNow) {
    return intl.formatMessage({id: 'ScheduleDropdown.State.Open'})
  }
  let dayOfWeek: number = date.getDay() // 0 is sunday
  dayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek - 1 // 0 is monday

  // Closed w/ no next opening time
  const currentOpenTime = scheduleOpenTimes.days[dayOfWeek]
  
  if (!currentOpenTime || currentOpenTime.openingHours.length === 0) {
    return intl.formatMessage({id: 'ScheduleDropdown.State.Closed'})
  }

  // Check for today's next opening hour
  if (currentOpenTime) {
    const todayOpeningHours = currentOpenTime.openingHours

    for (let i = 0; i < todayOpeningHours.length; i++) {
      const start = todayOpeningHours[i].opening.split(':')

      let startDate = new Date(date)
      startDate.setHours(parseInt(start[0]))
      startDate.setMinutes(parseInt(start[1]))
      
      if (date.getTime() < startDate.getTime()) {
        return intl.formatMessage({id: 'ScheduleDropdown.State.Opens.At'}, { hour: todayOpeningHours[i].opening})
      }
    }
  }
  // Not opening today
  return intl.formatMessage({id: 'ScheduleDropdown.State.Closed'})
}


export {
  openingStatusText
}
